module.exports = __webpack_public_path__ + "img/preview-mobile-1.76c7a989.png";